module.exports = __webpack_public_path__ + "img/growth.73b6a3a.webp";